import React from "react";

/** Vizualisan elválasztott blokk a hosszú feladási űrlaphoz. */
export function ListingFormSection({ title, hint, children, testid, accent = false }) {
  return (
    <div
      data-testid={testid}
      className={`rounded-2xl border p-5 md:p-6 ${
        accent
          ? "border-electric/30 bg-electric/[0.04]"
          : "border-white/10 bg-white/[0.02]"
      }`}
    >
      <div className="mb-4">
        <h3 className="font-heading text-base font-medium text-slate-100">{title}</h3>
        {hint ? <p className="text-xs text-slate-500 mt-1 leading-relaxed">{hint}</p> : null}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
    </div>
  );
}
